import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useAFBAdminDetail } from "./hooks/useAFBAdminDetail";
import { customStylesCompany } from "../../../util/TableStyles";
import { Card, Skeleton, FlexGrid, Typography, useThemeProvider, Link, Button } from "@albo-ui/core";
import { noDataComponent, afbOrderOptions, afbAdminInfo, status, afbAdminEdit, afbSearchOptions } from "../../../util/DataObject";
import { Select, MenuItem, InputLabel, FormControl, Box, CardActionArea, TextField, Divider, IconButton } from "@mui/material";
import { CustomMenu } from "../../elements";
import CustomSearchBar from "../../elements/SearchBar/CustomSearchBar";
import CustomPagination from "../../elements/CustomPagination";

import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
moment.locale("es");

export const AfbAdminDetail = ({sectionData, roles, action, config, afbNewActions, onHandleUpdateStatus, onHandleUpdate, onHandleCreate, onHandleWidgetChange, onOpenConfirm, onOpenDetail, otpTokenGetAllowed, dataReuse, changeLoader, changeAlert, catalogs}: any) => {
    const { data, form, codeCom, spaces, admins, companies, isValid, loading: loadingTable, searchInside, searchOutside, companyData, columnsCompany, columnsCompanyEdit, columnsAccount, columnsAccountEdit, internalAction, pagination, saveData, changePage, handleChangeRowsPerPage, onShowInfo, onGetAdmin, onAddAdmin, onGetCompany, onAddCompany, onHandleSearch, onHandleOrder, onHandleChange, onSelectForm } = useAFBAdminDetail(changeAlert, action, config, onOpenDetail);
    const { theme } = useThemeProvider();
    const [openDetail, setOpenDetail] = useState("");

    const filterOptions = [
        { key: "uuid", label: "UUID" },
        { key: "company_name", label: "Nombre" },
    ];

    const onHandlePayload = () => {
        let payload = {
            account_acl: form["account_acl"],
            company: form["company"],
            status: form["status"],
            phone: `+${codeCom}${form["admin"]["phone"]}`,
            email: form["admin"]["email"],
            gname: form["admin"]["gname"],
            lname: form["admin"]["lname"],
            slname: form["admin"]["slname"],
        };
        
        let confirm = null;
        if (action === "edit") {
            payload["uuid"] = form["uuid"];
            if(form["admin"].email === data["admin"].email && payload["phone"] === data["admin"].phone){
                confirm = true;
            }
        }

        return action === "edit" ? onHandleUpdate(payload, confirm) : onHandleCreate(payload);
    };

    const actionExecute = (item = data, key) => {
        switch (key) {
            case "dataReuseAfb":
                return dataReuse(data["uuid"]);
            case "otpTokenGetAllowed":
                return otpTokenGetAllowed(data, key);
            case "editAdmin":
                return onOpenDetail(data, "edit", afbNewActions);
            case "create":
                return onHandleWidgetChange();
            case "edit":
                return onOpenDetail(data, "detail", afbNewActions);
            default:
                return onOpenConfirm(data, key);
        }
    };

    const ExpandedComponent = () => {
        return (
            <FlexGrid item style={{ marginLeft: 48, width: "93%" }}>
                <DataTable
                    data={spaces}
                    columns={action !== "detail" ? columnsAccountEdit : columnsAccount}
                    customStyles={customStylesCompany}
                    noDataComponent={noDataComponent}
                />
            </FlexGrid>
        );
    };

    const userFields = (item) => {
        return (
            action !== "detail" ? 
            <FlexGrid key={item.key} item fullWidth>
                {showFields(item["section"], item["key"], item["label"], item["aux_label"], item["required"])}
            </FlexGrid>
            :
            <div key={item.key} style={{marginBottom: 10}}>
                <Typography variant="paragraph" color="lightNeutral" style={{width: "45%", paddingRight: 25}}>{item.label}:</Typography>
                <Typography variant="paragraph" style={{width: "55%", overflowWrap: "break-word"}}>
                {(item.key === "cdate" && moment(new Date(data["cdate"])).format("LL")) || data[item.key] || (item.key === "name" ? data["admin"] && `${data["admin"]["gname"]} ${data["admin"]["lname"]}` : data["admin"] && data["admin"][item.key])}
                </Typography>
            </div>
        );
    };

    const showFields = (prop1, prop2, label, aux_label = null, required ) => {
        if (prop2.includes("phone") && form) {
            return (
                <Box display={"flex"} key={`phone-${prop1}-${prop2}`}>
                    <FormControl variant="standard" fullWidth sx={{width: "55%", mr: 1}} required={required}>
                        <Select value={codeCom} onChange={onHandleChange.bind(this, "phone_code", null, null, form)} color="secondary" MenuProps={{style: {zIndex: 35001}}} inputProps={{ shrink: "true" }} fullWidth variant="outlined">
                            {catalogs["country"]?.map((item, index) => (
                                <MenuItem key={`country-${index}`} value={item.m[0].dial}>
                                    (+{item.m[0].dial}) {item.m[0].code2}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField value={form[prop1][prop2] || ""} onChange={onHandleChange.bind(this, prop1, prop2, "phone", form)} label={`${label} ${aux_label ? aux_label : ""}`} color="secondary" variant="outlined" sx={{ mb: 2 }} fullWidth InputLabelProps={{ shrink: true }} required={required}/>
                </Box>
            );
        } else {
            return <TextField key={`${prop1}-${prop2}`} required={required} color='secondary' variant='outlined' sx={{mb: 2}} fullWidth InputLabelProps={{ shrink: true }}
            value={
                prop2 && form[prop1] ? form[prop1][prop2] || "" :
                prop1 ? form[prop1] || "" : 
                form[prop2] || ''
            } onChange={onHandleChange.bind(this, prop1, prop2, null, form)} label={`${label} ${aux_label ? aux_label : ""}`} />
        }
    };

    const handleRowExpand = (isExpanded, row) => {
        if (isExpanded) {
            onShowInfo(row);
        }
    };

    const validateStatus = (row, list) => {
        let status = list?.filter((i) => {
            return i.status ? i.status === row.status ? i.validation ? !row.admin.email.includes("_REUSADO") : i : null : i;
        });
        return status;
    };

    useEffect(() => {
        saveData(sectionData, roles);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sectionData]);
    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    return (
        <>
            <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, marginBotton: 20}}>
                {loadingTable ? (
                    <Skeleton width="100%" height="100px"/>
                ) : (
                    <FlexGrid container fullWidth>
                        <FlexGrid container fullWidth style={{marginBottom: 20, display: "block"}}>
                            <FlexGrid item style={{width: "45%", marginBottom: 30}}>
                                <Link onClick={() => onHandleWidgetChange()} typography='paragraph'>Admins</Link>
                                <Typography variant="paragraph" > / Detalle de usuario</Typography>
                                { action === "detail" && data["admin"] && <Typography variant='h2' style={{display: 'flex', alignItems: 'center', fontSize: '1.2rem'}}>
                                    {data["admin"]["gname"]} {data["admin"]["lname"]}
                                </Typography>}
                            </FlexGrid>

                            <FlexGrid item spacing={2} container>
                                <FlexGrid item spacing={2} direction="column" fullWidth>
                                    {[action !== "detail" ? afbAdminEdit : afbAdminInfo][0].map((item, i) => i % 2 === 0 && userFields(item))}
                                </FlexGrid> 
                                <FlexGrid item spacing={2} direction="column" fullWidth>
                                    {[action !== "detail" ? afbAdminEdit : afbAdminInfo][0].map((item, i) => i % 2 !== 0 && userFields(item))}
                                </FlexGrid>
                            </FlexGrid>
                        </FlexGrid>

                        { action !== "detail" && <Divider orientation="vertical" sx={{pb: 40, mx: 3, height: "auto"}} />}

                        <FlexGrid container fullWidth style={{marginBottom: 5, display: "block"}}>
                            { action === "detail" ? <FlexGrid item container spacing={1} fullWidth justify="flex-end">
                                    {data["status"] && status && <FormControl>
                                        <InputLabel>Estatus</InputLabel>
                                        <Select value={data["status"]} onChange={onHandleUpdateStatus.bind(this, data)} disabled={data["status"] === "disabled" ? true : false} size='small' color='secondary' style={{height: "52px", width: 'auto', backgroundColor: "#ffffff"}}>
                                            {status.map((item) => {
                                                return <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>}
                                    <CustomMenu width={5} height={38} border size="small" row={null} options={validateStatus(data, afbNewActions)} action={actionExecute} icon={<MoreHorizIcon/>}/>
                                </FlexGrid>
                                :
                                <>
                                <Box mb={2} display="flex" justifyContent="space-evenly" gap={3}>
                                    <Card style={{ width: "100%", height: "fit-content", padding: 0}}>
                                        <CardActionArea onClick={() => onSelectForm("addCompany")} sx={{display: "flex", padding: "15px", backgroundColor: internalAction === "addCompany" ? "#e0ffdc" : "inherit"  }}> 
                                            <AddBusinessOutlinedIcon color="success" sx={{mr: 1}}/>
                                            <Typography variant="smallTitle">Agregar empresa</Typography>
                                        </CardActionArea>
                                    </Card>
                                    <Card style={{ width: "100%", height: "fit-content", padding: 0}}>
                                        <CardActionArea onClick={() => onSelectForm("importAccess")} sx={{display: "flex", padding: "15px", backgroundColor: internalAction === "importAccess" ? "#e5f6fd" : "inherit"  }}> 
                                            <FileCopyOutlinedIcon color="primary" sx={{mr: 1}}/>
                                            <Typography variant="smallTitle">Importar accesos</Typography>
                                        </CardActionArea>
                                    </Card>
                                </Box>

                                {internalAction && <FlexGrid item container direction="column" fullWidth>
                                    {(internalAction === "addCompany" ? <Typography variant='paragraph' style={{marginBlock: 15}}>Selecciona las empresas que serán asignadas al usuario.</Typography>
                                        : <Typography variant='paragraph' style={{marginBlock: 15}}>Al importar, se copiarán empresas, cuentas y permisos del usuario seleccionado.</Typography> )}

                                    <CustomSearchBar
                                        field={true}
                                        select={internalAction === "addCompany" && {
                                            options: afbSearchOptions,
                                            text: "Tipo",
                                            default: searchOutside["type"] || "uuid",
                                        }}
                                        onConfirm={internalAction === "addCompany" ? onGetCompany : onGetAdmin}
                                        textField={`Buscar ${internalAction === "addCompany" ? "empresa" : "usuario por email o teléfono"}...`}
                                        defaultField={searchOutside["value"] || null}
                                    />
                                    {internalAction === "addCompany" && companies.map((i) => {
                                        return <FlexGrid container key={i["uuid"]} style={{marginTop: 15}}>
                                            <IconButton sx={{backgroundColor: "#0000000a", width: "50px"}}><AccountBalanceIcon/></IconButton>
                                            <FlexGrid direction="column" item container style={{display: "flex", marginLeft: 10}} fullWidth>
                                                <Typography variant='smallTitle' style={{marginBlock: 1}}>{i.corporate_name}</Typography>
                                                <Typography variant='paragraph' style={{marginBlock: 1}}>{i.email}</Typography>
                                            </FlexGrid>
                                            <IconButton sx={{width: "50px"}} onClick={onAddCompany.bind(this, i)}><AddIcon /></IconButton>
                                        </FlexGrid>
                                    })}
                                    {internalAction === "importAccess" && admins.map((i) => {
                                        return <FlexGrid container key={i["uuid"]} style={{marginTop: 15}}>
                                            <IconButton sx={{backgroundColor: "#0000000a", width: "50px", height: "50px"}}><PersonIcon/></IconButton>
                                            <FlexGrid direction="column" item container style={{display: "flex", marginLeft: 10}} fullWidth>
                                                <Typography variant='smallTitle' style={{marginBlock: 1}}>{i.admin.gname} {i.admin.lname}</Typography>
                                                <Typography variant='paragraph' style={{marginBlock: 1}}>
                                                    {i.company.length} cuentas { i.company.length > 0 && <Link onClick={() => setOpenDetail(openDetail === i["uuid"] ? "" : i["uuid"])} typography='paragraph'>- {openDetail === i["uuid"] ? "Ocultar detalle" : "Ver detalle"}</Link>}
                                                </Typography>
                                                {openDetail === i["uuid"] && i.company.map((j) =>                                                
                                                    <Typography key={j["uuid"]} variant='paragraph' style={{marginBlock: 1}}>- {j.name}</Typography>
                                                )}
                                            </FlexGrid>
                                            <IconButton sx={{width: "50px"}} onClick={onAddAdmin.bind(this, i)}><AddIcon /></IconButton>
                                        </FlexGrid>
                                    })}
                                </FlexGrid>}
                                </>
                            }
                        </FlexGrid>
                    </FlexGrid> 
                )}
            </Card>

            <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, marginTop: 20}}>
                { loadingTable ? (
                    <Skeleton width="100%" height="100px" style={{ marginTop: 20 }}/>
                ) : (
                    companyData && <FlexGrid container fullWidth justify="space-between" style={{ marginBottom: 25, display: "block"}}>
                        <FlexGrid item justify="space-between" style={{ display: "flex" }}>
                            <FlexGrid>
                                <Typography variant="h2" style={{display: "flex", alignItems: "center", fontSize: "1.2rem"}}>
                                    <AccountBalanceIcon sx={{ marginRight: 1 }} />Cuentas y permisos
                                </Typography>
                                <Box my={1} sx={{ fontStyle: 'italic', fontWeight: '500 !important' }}>
                                    Empresas asignadas ({pagination.totalDocuments})
                                </Box>
                            </FlexGrid>
                            <FlexGrid item spacing={1} justify="flex-end" container fullWidth>
                                <CustomSearchBar
                                    field={true}
                                    select={{
                                        options: filterOptions,
                                        text: "Tipo",
                                        default: searchInside["type"] || "uuid",
                                    }}
                                    onConfirm={onHandleSearch}
                                    textField={"Buscar empresa..."}
                                    defaultField={searchInside["value"] || null}
                                    refreshType2
                                    refresh
                                />
                                <CustomMenu width={5} height={38} border size="small" row={null} options={afbOrderOptions} action={onHandleOrder} icon={<SwapVertIcon/>} />
                            </FlexGrid>
                        </FlexGrid>

                        <FlexGrid item fullWidth>
                            <DataTable
                                data={companyData}
                                columns={action !== "detail" ? columnsCompanyEdit : columnsCompany}
                                customStyles={customStylesCompany}
                                noDataComponent={noDataComponent}
                                expandableRows
                                expandableRowsComponent={ExpandedComponent}
                                onRowExpandToggled={handleRowExpand}
                                expandableRowExpanded={(row) => spaces.some((expanded) => expanded.customer_uuid === row.uuid)}
                            />
                        </FlexGrid>
                        <CustomPagination
                            rows={pagination.totalDocuments}
                            page={pagination.page}
                            rowsPerPage={pagination.rowsPerPage}
                            handleChangePage={changePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                        { action !== "detail" && <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }}>
                            <FlexGrid item>
                                <Button onClick={() => actionExecute(data, action)} buttonType="secondary" size="normal">Cancelar</Button>
                            </FlexGrid>
                            <FlexGrid item>
                                <Button onClick={onHandlePayload} disabled={isValid} size="normal" >Aceptar</Button>
                            </FlexGrid>
                        </FlexGrid>}
                    </FlexGrid>
                )}
            </Card>
        </>
    );
};
